import { webmaster } from '../services/ApiService';
import { webmasterConstants } from '../constants/webmaster';

export const setWallets = (wallets = []) => ({
  type: webmasterConstants.SET_WALLETS_SUCCESS,
  wallets,
});

export const startSetWallets = () => dispatch => {
  return webmaster
    .getWallets()
    .then((data = {}) => dispatch(setWallets(data.items)))
    .catch(err => dispatch({ type: webmasterConstants.SET_WALLETS_FAILURE }));
};

export const startCreateWallets = data => dispatch => {
  return webmaster
    .setWallets(data)
    .then(() => dispatch({ type: webmasterConstants.ADD_WALLETS_SUCCESS }));
};

export const deleteWallets = walletId => ({
  type: webmasterConstants.DELETE_WALLETS_SUCCESS,
  walletId,
});

export const startDeleteWallets = ({id}) => dispatch => {
  return webmaster
    .deleteWallets(id)
    .then(() => dispatch(deleteWallets(id)))
    .catch(err => dispatch({ type: webmasterConstants.DELETE_WALLETS_FAILURE }));
};

export const startUpdateWallets = data => () => {
  return webmaster.updateWallets(data);
};